import React, { useEffect } from 'react';
import { AutoResizer } from 'react-base-table';
import { Modal } from 'antd';
import {
  sensitivityLogsSelector,
  sensitivityLogsLoadingSelector,
} from '@store/aiAlerts/sensitivityControl/selectors';
import { useSelector, useDispatch } from 'react-redux';
import { fetchSensitivityLogs } from '@store/aiAlerts/sensitivityControl/actions';
import FeatureCheck from '@components/common/FeatureCheck';
import { Retry } from '@components/common';
import { featureSelector } from '@store/common/selectors';
import { CURRENT_PRODUCT_MODE } from '@src/utils/constants';
import { appAIAlertEnabledSelector } from '@utils/appInsights';
import {
  getDataForColumns,
  sensitivityLogColumns,
  sensitivityAdAlertLogColumns,
  getDataForAdColumns,
  getDataForAppColumns,
} from './formatter';
import { Wrapper, StyledBaseTable } from './styled';
import StyledTabs from '@components/common/Tabs';
const { TabPane } = StyledTabs;

const getDefaultActiveKey = () => {
  if (CURRENT_PRODUCT_MODE === 'AI') return 'ad-alert';
  if (CURRENT_PRODUCT_MODE === 'APP') return 'app-alert';
  return 'video-alert';
};

const SensitivityLogs = ({ isPopupOpen, closePopup }) => {
  const isLoading = useSelector(sensitivityLogsLoadingSelector);
  const logsData = useSelector(sensitivityLogsSelector);
  const dataSource = getDataForColumns(logsData);
  const appSource = getDataForAppColumns(logsData);
  const adDataSource = getDataForAdColumns(logsData);
  const isAdAlertsEnabled = useSelector(featureSelector('ad_ai_alerts'));
  const isAppAlertEnabled = useSelector(appAIAlertEnabledSelector);

  const dispatch = useDispatch();

  const defaultActiveKey = getDefaultActiveKey();

  useEffect(() => {
    dispatch(fetchSensitivityLogs());
  }, []);

  return (
    <Modal
      width="80vw"
      title="Sensitivity Logs"
      open={isPopupOpen}
      onCancel={closePopup}
      footer={[]}
    >
      <Wrapper>
        {isLoading ? (
          <Retry isLoading={isLoading} />
        ) : (
          <StyledTabs defaultActiveKey={defaultActiveKey}>
            <TabPane tab="Video Metric logs" key="video-alert">
              <AutoResizer>
                {({ width, height }) => (
                  <StyledBaseTable
                    data={dataSource}
                    columns={sensitivityLogColumns}
                    headerHeight={50}
                    estimatedRowHeight={100}
                    width={width}
                    height={height}
                  />
                )}
              </AutoResizer>
            </TabPane>
            <TabPane tab="Ad Metric logs" key="ad-alert">
              {isAdAlertsEnabled ? (
                <AutoResizer>
                  {({ width, height }) => (
                    <StyledBaseTable
                      data={adDataSource}
                      columns={sensitivityAdAlertLogColumns}
                      headerHeight={50}
                      estimatedRowHeight={100}
                      width={width}
                      height={height}
                    />
                  )}
                </AutoResizer>
              ) : (
                <FeatureCheck featureName="" />
              )}
            </TabPane>
            <TabPane tab="ECO Metric logs" key="app-alert">
              {isAppAlertEnabled ? (
                <AutoResizer>
                  {({ width, height }) => (
                    <StyledBaseTable
                      data={appSource}
                      columns={sensitivityLogColumns}
                      headerHeight={50}
                      estimatedRowHeight={100}
                      width={width}
                      height={height}
                    />
                  )}
                </AutoResizer>
              ) : (
                <FeatureCheck featureName="" />
              )}
            </TabPane>
          </StyledTabs>
        )}
      </Wrapper>
    </Modal>
  );
};

export default SensitivityLogs;
